import Vue from 'vue';
import Vuex from 'vuex';
import filter from './filter';
import store from './store';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    filter,
    store,
  },
});
